if (!customElements.get("countdown-timer")) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      // Parse endDate from the dataset as an ISO format
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (isNaN(this.endDate)) return;

      // Lazy load the countdown timer if not in a scrolling marquee
      if (!this.closest(".marquee-item")) {
        window.initLazyScript(this, this.init.bind(this));
      }
    }

    init() {
      // Define elements for each time part
      this.daysEl = this.querySelector(".js-days .countdown__number-part");
      this.hoursPart1El = this.querySelector(
        ".js-hours .countdown__number-part-1"
      );
      this.hoursPart2El = this.querySelector(
        ".js-hours .countdown__number-part-2"
      );
      this.minsPart1El = this.querySelector(
        ".js-mins .countdown__number-part-1"
      );
      this.minsPart2El = this.querySelector(
        ".js-mins .countdown__number-part-2"
      );
      this.secsPart1El = this.querySelector(
        ".js-secs .countdown__number-part-1"
      );
      this.secsPart2El = this.querySelector(
        ".js-secs .countdown__number-part-2"
      );

      // Define time constants in milliseconds
      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      // Get animation duration from CSS if applicable
      const numberTransitionDuration = getComputedStyle(this).getPropertyValue(
        "--countdown-number-transition-duration"
      );
      if (numberTransitionDuration) {
        this.numberTransitionDurationMS = CountdownTimer.durationToMS(
          numberTransitionDuration
        );
        this.animated = this.numberTransitionDurationMS > 0;
      }

      // Add transition elements if animation is enabled
      if (this.animated) {
        this.querySelectorAll(
          ".countdown__number:is(.js-hours, .js-mins, .js-secs) .countdown__number-part"
        ).forEach((el) => {
          el.innerHTML = "";
          const span1 = document.createElement("span");
          span1.className = "countdown__number-part-current";
          span1.textContent = "0";
          const span2 = document.createElement("span");
          span2.className = "countdown__number-part-previous";
          span2.textContent = "0";
          el.append(span1, span2);
        });
      }

      // Start the timer
      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
      this.setAttribute("loaded", "");
    }

    timer() {
      const now = new Date().getTime();
      const timeDiff = this.endDate - now;

      if (timeDiff < 0) {
        clearInterval(this.interval);
        this.setAttribute("loaded", "");
        return;
      }

      // Calculate days, hours, minutes, and seconds
      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor((timeDiff % this.day) / this.hour);
      const mins = Math.floor((timeDiff % this.hour) / this.minute);
      const secs = Math.floor((timeDiff % this.minute) / this.second);

      // Update days display
      this.daysEl.textContent = days;
      if (days === 0) {
        this.daysEl
          .closest(".countdown__item")
          .classList.add("countdown__item--is-0");
        this.daysEl.classList.add("countdown__number-part--is-0");
      }

      // Update hours, minutes, and seconds display
      this.setPartValue(this.hoursPart1El, String(hours).padStart(2, "0")[0]);
      this.setPartValue(this.hoursPart2El, String(hours).padStart(2, "0")[1]);
      this.setPartValue(this.minsPart1El, String(mins).padStart(2, "0")[0]);
      this.setPartValue(this.minsPart2El, String(mins).padStart(2, "0")[1]);
      this.setPartValue(this.secsPart1El, String(secs).padStart(2, "0")[0]);
      this.setPartValue(this.secsPart2El, String(secs).padStart(2, "0")[1]);

      this.setAttribute("loaded", "");
    }

    setPartValue(part, value, setZeroClass = false) {
      if (setZeroClass) {
        part.classList.toggle("countdown__number-part--is-0", value === "0");
      }

      // Handle animated transitions if applicable
      if (this.animated) {
        const current = part.querySelector(".countdown__number-part-current");
        if (value !== current.textContent) {
          const previous = part.querySelector(
            ".countdown__number-part-previous"
          );
          part.classList.add("countdown__number-part--start-transition");
          previous.textContent = current.textContent;
          current.textContent = value;
          setTimeout(() => {
            requestAnimationFrame(() =>
              part.classList.remove("countdown__number-part--start-transition")
            );
          }, 20);
        }
      } else {
        part.textContent = value;
      }
    }

    // Converts CSS transition duration (e.g., '0.3s') to milliseconds
    static durationToMS(duration) {
      if (duration.includes("ms")) {
        return parseInt(duration, 10);
      }
      if (duration.includes("s")) {
        return parseFloat(duration) * 1000;
      }
      throw new Error(`Duration unit not recognized: ${duration}`);
    }
  }

  customElements.define("countdown-timer", CountdownTimer);
}
